import { render, staticRenderFns } from "./EventsInformationModal.html?vue&type=template&id=774b8600&scoped=true&external"
import script from "./EventsInformationModal.vue?vue&type=script&lang=js"
export * from "./EventsInformationModal.vue?vue&type=script&lang=js"
import style0 from "./EventsInformationModal.scss?vue&type=style&index=0&id=774b8600&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774b8600",
  null
  
)

export default component.exports